export default __webpack_public_path__ + "media/images/landing-28-550x420-2f97f5ab1be6f5560968ff9432da3f22.jpg";